module.exports = __webpack_public_path__ + "assets/img/hcpimg5.2a0b2a4c.png";